/**
 * A class which represents a Icon component.
 * This defines the structure and the main behavior of the component.
 *
 * @param conf A JSON object, which contains the following parameters:
 *      iconPlacement: the placement of the date picker icon button depends on the opening mode
 *          (click mode: outside, focus mode: inside),
 *      $input: input element
 */

import $ from 'jquery';
import * as common from '../../../shared/modules/common';
import { render } from 'mustache';
import view from './datePickerView';

export default function Icon(conf) {
    var $view,
        $input = conf.$input;

    function removeIcon() {
        var $next = $input.next(),
            insideIcon = $next.hasClass('uwr-date-picker-icon-inside'),
            outsideIcon = $next.hasClass('uwr-date-picker-icon-outside');
        if (insideIcon || outsideIcon) {
            $next.remove();
        }
    }

    function addIconIntoInput($input, $view) {
        var iconId = common.generateUUID();
        $input.attr('readonly', 'readonly');
        $input.attr('data-icon-button-selector', '#' + iconId);
        $input.data('tooltipTarget', $input);
        $view.attr('id', iconId);
        $input.after($view);
    }

    function addIconAfterInput($input, $view) {
        $input.data('tooltipTarget', $view);
        $input.after($view);
    }

    function init() {
        var insideIcon = conf.iconPlacement === 'inside',
            iconTemplate = insideIcon ? view.iconInside : view.iconOutside;
        $view = $(render(iconTemplate, {}));
        removeIcon();
        if (insideIcon) {
            addIconIntoInput($input, $view);
        } else {
            addIconAfterInput($input, $view);
        }
    }

    this.getView = function () {
        return $view;
    };

    init();
}



//////////////////
// WEBPACK FOOTER
// ./widgets/DatePicker/js/datePickerIcon.js
// module id = 84
// module chunks = main